import gql from 'graphql-tag';

export const updateUserMutation = gql`
  mutation updateUser(
    $id: ID!
    $givenName: String
    $familyName: String
    $email: EmailAddress
    $isAdmin: Boolean
    $position: String
    $status: UserStatus
    $certificateNumber: String
  ) {
    data: updateUser(
      id: $id
      givenName: $givenName
      familyName: $familyName
      email: $email
      isAdmin: $isAdmin
      position: $position
      status: $status
      certificateNumber: $certificateNumber
    ) {
      id
      email
      givenName
      familyName
      certificateNumber
      isAdmin
      hasAccount
      position
      status
      employments {
        id
        __typename
      }
      __typename
    }
  }
`;

const updateUser = ({ client, params }) => {
  try {
    return client.mutate({
      mutation: updateUserMutation,
      variables: {
        id: params.id,
        ...params.data,
        certificateNumber: params.data.certificateNumber || null,
      },
    });
  } catch (e) {
    if (e.graphQLErrors && e.graphQLErrors.length) {
      const [error] = e.graphQLErrors;
      const message = error.message;
      throw new Error(message);
    }
    throw e;
  }
};

export default updateUser;
